﻿import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataService } from "../services/dataService";
import {CaseType} from '../models/Enums';

@Component({
    selector: "jax-personinformationcomponent",
    templateUrl: "./personInformation.component.html",
})
export class PersonInformationComponent {

    public data;
    private userID: number;
    private currentUser: any;
    public isCompleted = false;
    public validationMessage="";
    public CaseTypeEnum = CaseType;
    @Input() caseId: number;
    @Input() caseNumber: string;
    @Input() roleId: number;
    @Input() caseType: string;

    constructor(private dataService: DataService,  private router: Router) {

    }

    public ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.userID = this.currentUser.UserId;
        }

        this.isCompleted = false;
        this.validationMessage = ``;

        this.dataService.get("casedetail/personinformation?caseId=" + this.caseId + "&roleId=" + this.roleId + "&userId=" + this.userID).subscribe(
            (resp) => {
                this.data = resp;
                this.isCompleted = true;
            },
            (error) => {
                this.validationMessage = error.message;
                this.isCompleted = true;
            });
    }

    public removeCurrentCaseNumber(caseNumbers: string) :string {
        if (!(this.caseNumber || caseNumbers))
            return "";
        else {
            caseNumbers = caseNumbers.replace("," + this.caseNumber, "");
            caseNumbers = caseNumbers.replace(this.caseNumber + "," , "");
            caseNumbers = caseNumbers.replace(this.caseNumber, "").replace(/,(\s+)?$/, '');
            return caseNumbers;
        }
    }

    public ngOnDestroy() {
        }

}
